import React from 'react';
import AuthService from './authService.js';
import dateTimeHelper from '../Helpers/datetimeHelper.js';

export default class AvailabilityPlannerService extends React.Component {
  static GetMonth(userId, year, month) {
    const yrmo = dateTimeHelper.getYrMoFromDate(year, month);
    const authService = AuthService.getInstance();
    const url = `/api/AvailabilityPlanner/GetMonth?userId=${userId}&yrmo=${yrmo}&clearCache=true`;
    return authService.CallBackendFunction(url);
  }

  // officeIds: array of office ids (or a single id). An empty list means every office.
  static GetOfficeMonth(officeIds, year, month) {
    const yrmo = dateTimeHelper.getYrMoFromDate(year, month);
    const authService = AuthService.getInstance();
    const ids = Array.isArray(officeIds) ? officeIds.join(',') : officeIds ?? '';
    const url = `/api/AvailabilityPlanner/GetOfficeMonth?officeIds=${ids}&yrmo=${yrmo}&clearCache=true`;
    return authService.CallBackendFunction(url);
  }

  // Send the picked calendar date as a plain yyyy-MM-dd string using LOCAL components. A JS Date
  // serializes to UTC in JSON, which shifts a local-midnight date back a day in positive-offset zones
  // (e.g. 2026-07-24 -> 2026-07-23), so the backend would store the wrong day.
  static toDateOnly(value) {
    if (!value) return value;
    if (typeof value === 'string') return value.substring(0, 10);
    const d = new Date(value);
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${d.getFullYear()}-${month}-${day}`;
  }

  static SaveDay(item) {
    const authService = AuthService.getInstance();
    const url = `/api/AvailabilityPlanner/SaveDay`;
    const payload = {
      ...item,
      StartDate: AvailabilityPlannerService.toDateOnly(item.StartDate),
      EndDate: AvailabilityPlannerService.toDateOnly(item.EndDate),
    };
    return authService.CallBackendFunctionPost(url, JSON.stringify(payload));
  }

  // Availability statistics over a date range. officeScope=true uses officeIds (empty = all offices);
  // officeScope=false summarises the logged-in caller's own team (resolved on the backend).
  // Dates are yyyy-MM-dd; toDate is exclusive.
  static GetStats(officeScope, officeIds, fromDate, toDate) {
    const authService = AuthService.getInstance();
    const payload = {
      OfficeScope: !!officeScope,
      OfficeIds: Array.isArray(officeIds) ? officeIds : [],
      FromDate: fromDate,
      ToDate: toDate,
    };
    return authService.CallBackendFunctionPost('/api/AvailabilityPlanner/GetStats', JSON.stringify(payload));
  }

  // Upsert a user's yearly vacation allowance (days they may plan). Backend authorizes the caller.
  static SaveVacationAllowance(userId, year, allowedDays) {
    const authService = AuthService.getInstance();
    const payload = { UserId: userId, Year: year, AllowedDays: Number(allowedDays) || 0 };
    return authService.CallBackendFunctionPost(
      '/api/AvailabilityPlanner/SaveVacationAllowance',
      JSON.stringify(payload)
    );
  }

  static GetDefaultWorkLocation() {
    const authService = AuthService.getInstance();
    return authService.CallBackendFunction('/api/AvailabilityPlanner/GetDefaultWorkLocation?clearCache=true');
  }

  static SetDefaultWorkLocation(location) {
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPost(
      '/api/AvailabilityPlanner/SetDefaultWorkLocation',
      JSON.stringify({ Location: location })
    );
  }
}
